/**
 * Wraps standalone pages (Reminders, etc.) with the shared archive sidebar when a last-opened tree exists.
 */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ArchiveContextNav } from './ArchiveContextNav';
import { getLastOpenedTreeId } from '../../utils/archiveNavigation';
import { treeHref } from '../../utils/prettyArchiveLinks';
import { getApiBase } from '../../utils/apiBase';

const API = getApiBase();

export function ArchivePageShell({ children, exportProps = {} }) {
  const [tree, setTree] = useState(null);

  useEffect(() => {
    const tid = getLastOpenedTreeId();
    if (!tid) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/trees/${tid}`);
        if (!cancelled && data?.id) setTree(data);
      } catch {
        if (!cancelled) setTree(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!tree?.id) {
    return children;
  }

  return (
    <div className="flex min-h-screen bg-background">
      <ArchiveContextNav
        treeId={tree.id}
        treeLinkBase={treeHref(tree)}
        treeName={tree.name}
        variant="tree"
        peopleCount={tree.people_count ?? 1}
        {...exportProps}
      />
      <div className="flex min-h-0 min-w-0 flex-1 flex-col pb-[calc(5.25rem+env(safe-area-inset-bottom,0px))] lg:pb-0">
        {children}
      </div>
    </div>
  );
}

export default ArchivePageShell;
